module.exports = __webpack_public_path__ + "static/media/ks_shack_quiz_tablet.51874dfc.png";